import Swiper from 'swiper';
// import 'remodal';

// スクロール
var Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	var smoothScrollTriggers = document.querySelectorAll('.anchor');
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
		smoothScrollTrigger.addEventListener('click', function (e) {
			var href = smoothScrollTrigger.getAttribute('href');
			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
			var targetElement = document.getElementById(href.replace('#', ''));
			if (targetElement) {
				e.preventDefault();
				e.stopPropagation();
				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 70;
				var startTime = performance.now();
				var loop = function (nowTime) {
					var time = nowTime - startTime;
					var normalizedTime = time / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};
				requestAnimationFrame(loop);
			}
		});
	});

	// スクロールアニメーション;
	funcAnim();
});

window.addEventListener('load', function () {
// スライダー
let slide = document.querySelectorAll('.keyvisual .slide');
for (let i = 0; i < slide.length; i++) {
	const swiper = document.querySelectorAll('.keyvisual .swiper-container')[i];
	new Swiper(swiper, {
		loop: true,
		// watchOverflow: true, // loopと併用不可
		effect: 'fade',
		speed: 800,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: document.querySelectorAll('.keyvisual .swiper-pagination')[i],
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: document.querySelectorAll('.keyvisual .swiper-button-next')[i],
			prevEl: document.querySelectorAll('.keyvisual .swiper-button-prev')[i],
		},
	});
}
});

const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		// root: root,
		rootMargin: '0px 0px -10% 0px',
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
